import React from 'react'
import { NavLink } from 'react-router-dom'
import {useState,useEffect} from 'react'
import axios from 'axios'
function AttributeGroups() {
  const HandleClickdelete = (AttributeGroupid) => {
    axios.delete(process.env.REACT_APP_API_URL+`/api/AttributeGroup/${AttributeGroupid}`)
      .then((res) => {
        console.log(res);
        console.log(res.data);
        window.location.href = "/AttributeGroup";
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const [AttributeGroup,setAttributeGroup] = useState([])
    useEffect(() => {
        axios
          .get(process.env.REACT_APP_API_URL+'/api/AttributeGroup/GetAttributeGroup').then((res) => {setAttributeGroup(res.data)}).catch((err) => {console.error(err);});
        });


  return (
    <>
    
      
      <div>
      <div className="h-10 m-0 p-0 bg-slate-500 opacity-30" style={{borderRadius:'4px'}}>
          <input type="text" className=" m-2" style={{borderRadius: '4px'}} placeholder="Search"/>
        </div>
<section class="mx-auto w-full max-w-7xl px-4 py-4">
  <div class="flex flex-col space-y-4 md:flex-row md:items-center md:justify-between md:space-y-0">
    
    
  </div>
  <div className='flex justify-between mt-5 mr-2'>
    <h2 class="text-lg font-semibold">Attribute Groups</h2>
    <NavLink to='/AttributeGroups/CreateAttributeGroup'><button className='rounded-md bg-black px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-black/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black'>Create Attribute</button></NavLink>
  </div>
  <br/>
  <div className='flex'>
    <select value='ALL'>
      <option value="All">ALL</option>
      <option value="FILTER"><input type="checkbox"/><span>Filter</span> </option>
      <option value="MY"><input type="checkbox"/><span>MY</span> </option>
      <option value="Active"><input type="checkbox"/><span>Active</span> </option>
      <option value="Delete"><input type="checkbox"/><span>Delete</span> </option>
    </select>
    <input 
    type="text" 
    placeholder="Search" 
    className="w-full px-3 py-2 border-b-2" 
  />
  <button type="submit" className="flex items-center justify-center w-auto px-4 py-2 bg-blue-500 text-white">
    <img alt="Search" className="w-4 h-4"/>
  </button>
  </div>
  <br/>
  <div class="mt-6 flex flex-col">
    <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
        <div class="overflow-hidden border border-gray-200 md:rounded-lg">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th scope="col" class="px-1 py-3.5 text-left text-sm font-normal text-gray-700">
                  <span><input type="checkbox" /> </span></th>
                <th
                  scope="col"
                  class="px-4 py-3.5 text-left text-sm font-normal text-gray-700"
                >
                  <span>Group Name</span>
                </th>
                <th
                  scope="col"
                  class="px-12 py-3.5 text-left text-sm font-normal text-gray-700"
                >
                 Code
                </th>
                <th
                  scope="col"
                  class="px-4 py-3.5 text-left text-sm font-normal text-gray-700"
                >
                  Sort Order
                </th>
                
                <th scope="col" class="relative px-4 py-3.5">
                  <span class="sr-only">Edit</span>
                </th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 bg-white">
            {AttributeGroup.map((brand) => (
              <tr key={AttributeGroup.id }>
                <td class="px-1 py-4 whitespace-nowrap"> <input type='checkbox' className='w-5 h-5'/> </td>
                <td>
                  <div class="flex items-center pl-5">
                   {AttributeGroup.groupname}
                  </div>
                </td>
                <td class="whitespace-nowrap px-12 py-4">
                  <div class="text-sm text-gray-900 "> {AttributeGroup.code} </div>
                
                </td>
                <td class="whitespace-nowrap px-4 py-4">
                  <span class="inline-flex   px-2 text-xs font-semibold leading-5">
                   {AttributeGroup.sortorder}
                  </span>
                </td>
                
                <td class="whitespace-nowrap px-4 py-4 text-right text-sm font-medium">
                  
                 <NavLink to={'/AttributeGroups/EditAttributeGroup/${AttributeGroup.id}'}> <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                    Edit
                  </button></NavLink>
                  <span className="pl-2">
                    <button className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded" onClick={()=>HandleClickdelete(brand.id)}>
                      Delete
                    </button>
                  </span>
                 

                </td>
              </tr>
            ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</section>
      </div>
     
    </>
  )
}

export default AttributeGroups